export default "__VITE_ASSET__C9MDtCz2__"